/**
 * Platform detection utilities
 * Helps determine if the app is running in Electron or Web mode
 */

// Check if running in Electron environment
export const isElectron = (): boolean => {
  // Check for window.electronAPI (exposed via preload script)
  if (typeof window !== "undefined" && window.electronAPI?.isElectron) {
    return true;
  }

  // Fallback check for Electron environment
  if (
    typeof navigator !== "undefined" &&
    navigator.userAgent.toLowerCase().includes("electron")
  ) {
    return true;
  }

  return false;
};

// Check if running in development mode
export const isDevelopment = (): boolean => {
  return import.meta.env.DEV;
};

// Check if running in production mode
export const isProduction = (): boolean => {
  return import.meta.env.PROD;
};

// Get current platform
export const getPlatform = (): "windows" | "macos" | "linux" | "web" => {
  if (!isElectron()) {
    return "web";
  }

  const platform = window.electronAPI?.platform;

  switch (platform) {
    case "win32":
      return "windows";
    case "darwin":
      return "macos";
    case "linux":
      return "linux";
    default:
      return "web";
  }
};

// Get app version (Electron only)
export const getAppVersion = async (): Promise<string> => {
  if (isElectron() && window.electronAPI) {
    return await window.electronAPI.getAppVersion();
  }
  return import.meta.env.VITE_APP_VERSION || "1.0.0";
};

// Open external URL
export const openExternal = async (url: string): Promise<void> => {
  if (isElectron() && window.electronAPI) {
    await window.electronAPI.openExternal(url);
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
